<template>
  <div class="main">
    <div class="box">
      <el-input v-model="input" placeholder="请输入删除的简历手机号"></el-input>
      <el-row>
        <el-button type="primary" @click="search">删除</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  data() {
    return {
      input: ""
    };
  },
  created() {},

  methods: {
    search() {
      let obj = {
        // token: this.$cookies.get("token"),
        phone: this.input
      };
      require("post", "/hr24_resume/v1/resume_delete/", obj).then(res => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.el-input {
  width: 20%;
  margin-right: 5px;
}

.box {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/user_management/delete_resume.vue